/**
 * Page Props Store
 *
 * Simple non-React store for Inertia page props.
 * Used by AppLayout (class component) to access page data
 * without React hooks, working around a Safari bug where
 * ReactSharedInternals.H is null during AppLayout render.
 */

type Listener = () => void

let currentProps: Record<string, any> = {}
const listeners = new Set<Listener>()

export const pageStore = {
  getProps(): Record<string, any> {
    return currentProps
  },

  setProps(props: Record<string, any>) {
    currentProps = props
    listeners.forEach((fn) => fn())
  },

  subscribe(fn: Listener): () => void {
    listeners.add(fn)
    return () => listeners.delete(fn)
  },
}
